import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const DummyCutoffAllTable = ({ report, onSortChange, updateFactor }) => {
    const rows = report.map((row, index) => (<Row {...row} updateFactor={updateFactor} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('affid')}>Affid</th>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('cutoff')}>Cutoff</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default DummyCutoffAllTable;


// WEBPACK FOOTER //
// ./src/scenes/DummyCutoffAll/components/Table/index.js